export const PERSISTENT_MESSAGE_TIMEOUT = -1;
export const DEFAULT_MESSAGE_TIMEOUT = 10000; // 10 seconds
